import { getProductOperationDetail } from '@repo/accounts-services'
import { defineSagaForService } from '@repo/core'
import { productOperationDetailDataActions } from '../../../../../slices'

export const serviceConfig = defineSagaForService({
  [productOperationDetailDataActions.getRequest.type]: {
    apiClientDomain: 'accounts',
    service: getProductOperationDetail,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: productOperationDetailDataActions.getResponse.type,
    actionTypeRequest: productOperationDetailDataActions.getRequest.type,
  },
})
